import { useEffect } from 'react';

export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

      // Disable scrolling, but keep space for scrollbar
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      // Re-enable scrolling and remove the reserved space for the scrollbar
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '0px';
    }
  }, [isLocked]);
};
